import React, { Component } from "react";
import Header from "../Login/Header";
import Footer from "./Footer";
class Privacy extends Component {

  componentDidMount() {

  }

  render() {


    return (
      <React.Fragment>
        <div className="container-fluid full-width nopadding">
          <div className="row nomargin">
            <div className="col-sm-12 header-color">
              <Header />
            </div>
          </div>
          <section class="breadcrumb-area">
            <div class="container">
              <div class="row">
                <div class="col-lg-12 col-sm-12 col-xs-12">
                  <div class="left-side pull-left headng">
                    <h1>Privacy Policy </h1>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <div class="about-page">

            <section className="py-4">
              <div className="container">
                <div className="row no-margin">
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="privacy-page">
                        <p>
                          BeWise recognizes the importance of maintaining your privacy. We value your
                          privacy and appreciate your trust in us. This privacy policy is being
                          published in accordance with the provisions of the applicable provisions of
                          laws in India.
                    </p>
                        <p>
                          This policy describes how we treat user information we collect on the Device
                          Support Application (“App”)/ website (named BeWise.in). This Privacy Policy
                          applies to current and former visitors to our App/ website. By visiting and/or
                          using our App/ website, you agree to this Privacy Policy.
                    </p>
                        <p>This privacy policy was updated in September, 2020.</p>
                        <h5>1. General</h5>
                        <p>
                          For the purpose of this Privacy Policy, wherever the context so requires,
                          ‘you’ or ‘user’ shall mean any natural or legal person who uses our
                          App/website, browses our website or becomes a member of our website by signing
                          up on BeWise as a user. BeWise allows the user to surf this website without
                          signing up on this website. The term “we”, “us”, “our” shall mean BeWise and
                      the term ‘site’ or ‘website’ refers to{" "}
                          <a href="www.bewise.in">www.BeWise.in</a>.
                    </p>
                        <h5>2. Information we collect</h5>
                        <p>
                          Depending on your interaction with us (meaning, if you are just browsing our
                          website, or if you have signed up on this website, etc.), we may collect two
                          types of information from you, i.e. ‘Personal Information’ and ‘Non-Personal
                          Information’.
                    </p>
                        <h6>a) Personal Information</h6>
                        <p>
                          Personal Information is the information that identifies a specific ‘End User’.
                          When you engage in certain activities on this website/App, such as signing up,
                          posting a review, rating a partner or any other third party listed on
                          our website/App, requesting information about our services or the services of
                          the third party partners listed on our website/App (collectively,
                          “Activities”), we may ask you to provide certain information about yourself or
                          your ward. It is optional for you to engage in an Activity. If you elect to
                          engage in an Activity, we may ask you to provide us with certain personal
                          information about yourself, such as your first and last name, email address,
                          telephone number, child’s name, age, etc. BeWise allows the user to sign up on
                          this website using social networking sites such as Facebook, Instagram, Google
                          accounts and LinkedIn, whereby, the user’s data may be shared by such social
                          networking sites with us.
                    </p>
                        <p>
                          Depending on the activity, some of the information we ask you to provide is
                          identified as mandatory and some is identified as voluntary. If you do not
                          provide the mandatory information for a particular activity that requires it,
                          you will not be permitted to engage in that activity.
                    </p>
                        <p>
                          We use Personal Information to enhance the operation of this website/App,
                          improve our marketing and promotional efforts, analyze website/App use,
                          improve our listings on the website/App, to personalize your experience and to
                          understand how our users, as a whole, use the services and resources provided
                          on our site/App and to provide you a better experience.
                    </p>
                        <p>
                          In addition to this, your Personal Information may be used to troubleshoot,
                          resolve disputes, accomplish administrative tasks, contact you, enforce our
                          agreements with you, including our website Terms and Conditions and this
                          Privacy Policy, comply with applicable law, and cooperate with law enforcement
                          activities.
                    </p>
                        <h6>b) Non-Personal Information</h6>
                        <p>
                          Non-Personal Information is the information that does not identify a specific
                          End User. This type of information may include things like the Uniform
                          Resource Locator (“URL”) of the website you visited before coming to our
                          website, the URL of the website you visit after leaving our website, the type
                          of browser you are using and your Internet Protocol (“IP”) address.
                    </p>
                        <p>
                          We use Non-Personal Information to troubleshoot, administer this website/App,
                          analyze trends, gather demographic information, comply with applicable law,
                          and cooperate with law enforcement activities.
                    </p>
                        <h6>3. Utilising user’s information</h6>
                        <p>
                          The information/data collected is used for the purposes of understanding the
                          user along with the location the user is from through geolocation platform, to
                          analyse our audience. Collecting this data helps us understand what you are
                          looking from the company, enabling us to deliver improved services.
                    </p>
                        <p>We may use your data for the following general purposes:</p>
                        <ul>
                          <li> To contact you in response to a specific enquiry</li>
                          <li> To improve the services that we provide</li>
                          <li> To customise the website/App for you</li>
                          <li> For our internal records</li>
                          <li>
                            To send you promotional emails about products, services, offers and other
                            things we think might be relevant to you.
                      </li>
                          <li>
                            To contact you via email, telephone or mail for market research reasons.
                      </li>
                        </ul>
                        <h5>4. Release of user’s information</h5>
                        <p>
                          We may disclose your information to other entities within BeWise’s company
                          group and its partners, for legitimate business purposes (including
                          operating the services, and providing services to you), in accordance with
                          applicable law. We may also disclose your information to any relevant
                          third-party partners listed on our website/App such as /preschools/
                          after school activity centers/schools/tuition centres/community support
                          centres, etc. for the purpose of providing appropriate services to you as per
                          your request.
                    </p>
                        <p>
                          We will not sell, trade, distribute or lease your personal information to
                          third parties unless we have your permission or if required to do so by law or
                          in the good faith belief that such disclosure is reasonably necessary to
                          respond to court orders or other legal process.
                    </p>
                        <h5>5. Security</h5>
                        <p>
                          We are committed to ensuring that your information is secure, but please note
                          that no method of transmission over the internet, or method of electronic
                          storage, is 100% secure. However, we will always hold your information
                          securely and prevent unauthorised disclosure or access to your information.
                          Further, by providing your information you allow us to share your information
                          with our partner brands/partners for their promotional purposes.
                    </p>
                        <p>
                          For general web browsing, no Personal Information is revealed to us, although
                          certain statistical information is available to us via our internet service
                          provider. This information may include the logical address of the server you
                          are using, the top level domain name from which you access the internet (for
                          example, .com, .in, etc.), the type of browser you are using, the date and
                          time you access our site and the internet address used to link to our site.
                    </p>
                        <p>
                          Some of the above information is used to create summary statistics, which
                          allow us to assess the number of visitors to our site and to identify what
                          pages of our site are accessed most frequently. We use these statistics to
                          help us make our site more user friendly.
                    </p>
                        <h5>6. Miscellaneous Privacy Issues</h5>
                        <p>
                          This website/App is not meant to be used directly by children/minors under the
                          age of 18, and/or any person who is not capable of entering into a binding
                          contract. We do not collect or maintain information from anyone known to be
                          under the age of 18, unless such information has been lawfully provided by the
                          parents or guardians of the children and no part of this website/App is
                          designed to directly attract anyone under the age of 18 and/or any person who
                          is not capable of entering into a binding contract. If you are under 18, or
                          are not capable of entering into a binding contract, and still want to use
                          this website/App, you may use BeWise only with the involvement of a parent or
                          guardian.
                    </p>
                        <p>We do not share, transfer, sell or trade children's information.</p>
                        <p>
                          We may provide areas on our website/App where you can publicly post
                          information about yourself and provide reviews and ratings for the individual
                          and institutional partners listed on our website/App. This
                          information may be accessible by other users and may appear on other websites
                          or web searches, and therefore this information is not confidential and could
                          be read, collected, and used by others.
                    </p>
                        <h5>7. Links to external sites</h5>
                        <p>
                          Information on our website/App may include some links which may lead to other
                          websites, including those operated and maintained by third parties or such
                          other third-party sites that might be directly or indirectly related to the
                          individual or institutional partners listed on our website/App.
                          BeWise includes these links solely as a convenience to you and the presence of
                          such a link does not imply a responsibility on BeWise for the linked site or
                          an endorsement of the linked site, its operator, or its contents.
                    </p>
                        <p>
                          Please be aware that once you click on the link to one of these sites, you
                          will be subject to that site's privacy policy and not to ours. We recommend
                          that you examine each website's Privacy Policy separately.
                    </p>
                        <p>
                          Apart from this website/App, the users may contact/ connect with BeWise using
                          social networking services such as Facebook, Twitter, LinkedIn and Instagram.
                          When you connect with us using these services, we may collect your personal
                          information to communicate with you. The social networking service will also
                          handle your personal information for its own purposes. These social networking
                          services have their own privacy policies. You can access the privacy policies
                          for these social networking services on their respective websites.
                    </p>
                        <h5>8. Cookies</h5>
                        <p>
                          This website uses “cookie” technology. A cookie is a small piece of data or a
                          small text file stored by the browser on your computer, at the request of our
                          server. We may use cookies to deliver content specific to your interests and
                          to save your personal preferences so you do not have to re- enter them each
                          time you connect to our website – our cookies are not available to other
                          websites. In particular cookies enable us:
                    </p>
                        <ul className="list-dot">
                          <li>to measure visitor traffic to our website and their usage patterns</li>
                          <li>to identify whether you are signed in to our website</li>
                          <li>
                            to test content on our website and pattern of a user on the website. For
                            instance, 50% of our users might see one piece of content, the other 50% a
                            different piece of content.
                      </li>
                          <li>
                            to store information about your preferences and so allow us to customize our
                            website according to your individual interests
                      </li>
                          <li>to speed up your searches</li>
                          <li>to recognize you when you return to our website</li>
                        </ul>
                        <p>
                          You are always free to decline such cookies, if your browser permits, or to
                          ask your browser to indicate when a cookie is being sent. You can also delete
                          cookie files from your computer at your discretion. However, please note that
                          doing this may affect how our website functions. Some pages and services may
                          become unavailable to you.
                    </p>
                        <p>
                          To learn more about cookies and how they are used, visit{" "}
                          <a href="http://www.allaboutcookies.org/">http://www.allaboutcookies.org/</a>.
                    </p>
                        <h5>9. Advertising cookies</h5>
                        <p>
                          Some of the advertisements you see on BeWise are provided by other
                          organizations. These organizations can use their own anonymous cookies to
                          track how many people have seen a particular ad, or to track how many people
                          have seen it more than once.
                    </p>
                        <p>
                          The entities that generate these cookies have their own privacy policies, and
                          we have no access to read or write these cookies. These organizations may use
                          their cookies to anonymously target advertising to you on other websites,
                          based on your visit to BeWise.
                    </p>
                        <h5>10. Electronic communication</h5>
                        <p>
                          There are inherent risks associated with the transmission of information over
                          the internet, including via email. You should be aware of this when sending
                          your personal information to us via email or via our website/App or social
                          media platforms. If this is of concern to you then you may use other methods
                          of communication with us, such as post or telephone (although these also have
                          risks associated with them).
                    </p>
                        <h5>11. Changes to this privacy policy</h5>
                        <p>
                          Please note that the privacy policy may change from time to time. BeWise
                          reserves the right to change this policy at any time. The users registered on
                          this website/App as a member shall be notified of the changes or
                          modifications, if any, done on this policy via their registered email by
                          BeWise.
                    </p>
                        <h5>12. Your Acceptance of these terms</h5>
                        <p>
                          By using this website/App, you signify your acceptance of our privacy policy.
                          If you do not agree to this policy, please do not use our website/App. Your
                          continued use of this website/App following the posting of changes to this
                          policy, as and when notified to you, will be deemed your acceptance of those
                          changes.
                    </p>
                        <h5>13. Jurisdiction</h5>
                        <p>
                          If you choose to visit this website/App, your visit and any dispute over data
                          privacy is subject to this policy and the terms and conditions of this
                          website/App. In addition to the foregoing, any disputes arising under this
                          policy shall be governed by the laws of India and the courts of Karnataka
                          shall have exclusive jurisdiction in determining such dispute.
                    </p>
                        <h5>14. Complaints</h5>
                        <p>
                          If you think BeWise may have breached your privacy, you may contact us to make
                          a complaint and rectify our actions. In order to ensure that we fully
                          understand the nature of your complaint and the outcome you are seeking, we
                          prefer that you make your complaint in writing via email to the below
                          mentioned email address.
                    </p>
                        <p>
                          Further, in accordance with Information Technology Act, 2000 and rules made
                          thereunder, the name and contact details of the grievance officer who can be
                          contacted with respect to any complaints or concerns including those
                          pertaining to breach of BeWise’s Terms & Conditions, and other polices or
                          questions are published as under:
                    </p>
                        <p>
                          Name: Sethuraman
                      <br />
                      Email Address: <a href="mailto:contact@bewise.in">contact@bewise.in</a>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
        <Footer />

      </React.Fragment>
    );
  }
}

export default Privacy;



// WEBPACK FOOTER //
// ./src/components/Copyrights/privacy.jsx